import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import ClipLoader from 'react-spinners/ClipLoader';

function FileUploadPage(_ref) {
  var _ref$doAfter = _ref.doAfter,
      doAfter = _ref$doAfter === void 0 ? function () {} : _ref$doAfter,
      _ref$doOnError = _ref.doOnError,
      doOnError = _ref$doOnError === void 0 ? function () {} : _ref$doOnError;

  var _useState = useState(),
      ImgUrl = _useState[0],
      setImgUrl = _useState[1];

  var _useState2 = useState(false),
      Uploading = _useState2[0],
      setUploading = _useState2[1];

  var hiddenFileInput = React.useRef(null);

  var handleClick = function handleClick(event) {
    if (!getCookie(document.cookie, "uid") || !getCookie(document.cookie, "dugolyToken")) {
      alert("you have to login before uploading");
    } else {
      hiddenFileInput.current.click();
    }
  };

  var changeHandler = function changeHandler(event) {
    var fileData = event.target.files[0];
    setUploading(true);
    var formData = new FormData();
    var uid = getCookie(document.cookie, "uid");
    var token = getCookie(document.cookie, "dugolyToken");
    formData.append("uid", uid);
    formData.append("token", token);
    formData.append("photo", fileData);
    var responseStatus = 2222;
    fetch('https://www.easydone.online/upload', {
      method: 'POST',
      body: formData
    }).then(function (response) {
      responseStatus = response.status;
      return response.json();
    }).then(function (result) {
      if (responseStatus > 199 && responseStatus < 300) {
        setImgUrl(result);
        doAfter(result);
      } else {
        doOnError("response status is:  ", responseStatus);
      }

      setUploading(false);
    })["catch"](function (error) {
      console.error('Error 1:', error);
      setUploading(false);
      doOnError(error);
    })["catch"](function (error) {
      console.error('Error 2:', error);
      setUploading(false);
      doOnError(error);
    });
  };

  return /*#__PURE__*/React.createElement("div", null, Uploading ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ClipLoader, {
    loading: true,
    size: 50
  }), /*#__PURE__*/React.createElement("br", null), "Uploading data, please wait") : /*#__PURE__*/React.createElement("div", {
    className: "Insertimg",
    style: {
      width: "100%",
      boxSizing: "border-box",
      margin: "0px 0px 30px 0px"
    }
  }, ImgUrl && /*#__PURE__*/React.createElement("img", {
    className: "imagse",
    src: ImgUrl,
    alt: "",
    style: {
      width: "140px",
      height: "140px",
      boxSizing: "border-box",
      objectFit: "scale-down",
      margin: "10px 0px",
      display: "block"
    }
  }), !ImgUrl && /*#__PURE__*/React.createElement("div", {
    className: "btns",
    style: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      boxSizing: "border-box",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap"
    }
  }, /*#__PURE__*/React.createElement(Button, {
    className: "imgbtn",
    onClick: handleClick,
    style: {
      width: "40%",
      minWidth: "100px",
      backgroundColor: "#5381ff",
      boxSizing: "border-box",
      textTransform: "capitalize",
      color: "white",
      textAlign: "center",
      fontWeight: "100",
      fontSize: "14px",
      padding: "10px 0px",
      border: "none",
      outline: "none",
      marginBottom: "10px"
    }
  }, "Add Image")), /*#__PURE__*/React.createElement("input", {
    type: "file",
    name: "file",
    onChange: changeHandler,
    ref: hiddenFileInput,
    style: {
      display: 'none'
    }
  }), " "));
}

function getCookie(cookies, cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(cookies);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return null;
}

var index = (function (_ref) {
  var callback = _ref.callback,
      onError = _ref.onError;
  return /*#__PURE__*/React.createElement(FileUploadPage, {
    doAfter: callback,
    doOnError: onError
  });
});

export default index;
//# sourceMappingURL=index.modern.js.map



//////////////////
// WEBPACK FOOTER
// ./~/dugoly-uploader/dist/index.modern.js
// module id = 175
// module chunks = 0